import { Typography, Alert, Button, Grid, Popover, Stack } from "@material-ui/core";
import React, { useContext, useState } from "react";
import { AuthContext } from './AuthContext';
import { makeStyles } from '@material-ui/styles';
import CheckIcon from '@material-ui/icons/Check'
import { Link, CircularProgress, Backdrop, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText } from "@material-ui/core";
import MetamaskOnboarding from '@metamask/onboarding';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import ErrorIcon from '@material-ui/icons/Error';
import SellIcon from '@material-ui/icons/Sell';

const useStyles = makeStyles(theme => ({
    root: {
        minHeight: "70vh",
        width: '100%',
        height: '100%',
    },
    content: {
        padding: 50,
        backgroundColor: theme.palette.secondary.main
    },
    productName: {
        fontSize: 48,
        fontFamily: 'Dela Gothic One',
        textAlign: 'center',
        margin: '0 auto',
        marginBottom: 16,
    },
    productMeta: {
        margin: '0 auto'
    },
    productDesc: {
        fontSize: 22,
        margin: '0 auto'
    },
    center: {
        textAlign: 'center'
    },
    hr: {
        margin: '35px 0',
        borderTop: `1px solid ${theme.palette.primary.main}`
    },
    actionButton: {
        maxWidth: 400,
        padding: 100,
        display: 'inline-block',
    },
    owned: {
        maxWidth: 400,
        margin: '0 auto'
    },
    secretContent: {
        padding: 20,
        border: '1px solid #CCC',
        borderRadius: 4,
        margin: 10,
        backgroundColor: 'white'
    },
    badge: {
        display: 'inline-block',
        padding: '5px 12px',
        fontWeight: 800,
        border: '2px solid',
        borderRadius: 12
    },
    price: {
        backgroundColor: theme.palette.highlight.main,
        borderColor: theme.palette.highlight.main,
    },
    seller: {
        color: 'white',
        backgroundColor: 'darkgray',
        borderColor: 'darkgray',
    },
    ownerBadge: {
        backgroundColor: '#73e250',
        borderColor: '#73e250',
    },
    failedBadge: {
        backgroundColor: 'red',
        borderColor: 'red',
    },
    pendingBadge: {
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
    },
}));

export const Product = ({ product, purchase = {}, onPurchase, onDownload }) => {
    const { metamask, isLoggedIn, isConnected, login, connect, address } = useContext(AuthContext);
    const [status, setStatus] = useState(null);
    const classes = useStyles();
    const [helloMetamask, setHelloMetamask] = useState(false);

    const hasPurchased = product.purchasers?.some(p => p === address);
    const isOwner = product.userId && product.userId.toLowerCase() === address?.toLowerCase();
    const isFile = !!product.file;
    const isText = !!product.body;

    const doMetamaskOnboarding = () => {
        new MetamaskOnboarding().startOnboarding();
      };

    const _onPurchase = async values => {
        if (isOwner || hasPurchased) {
            return;
        }

        if (!metamask) {
            setHelloMetamask(true);
            return;
        }
        
        let _address = address;
        if (!isConnected) {
            setStatus('Connecting to Metamask...')
            _address = await connect();
            setStatus('Connected!')
        }

        if (!isLoggedIn) {
            setStatus('Logging you in...')
            await login(_address);
        }

        setStatus('Purchasing...')
        await onPurchase(values, setStatus);
    }

    const PurchasedToolbar = () => (
        <>
            {isText && (
                <>
                    <h2>Secret Contents</h2>
                    <div className={classes.secretContent}>{product.body}</div>
                </>
            )}
            {isFile && (
                <Button
                    className={classes.actionButton}
                    variant='contained'
                    onClick={() => onDownload()}
                >
                    Download
                </Button>
            )}
        </>
    );

    const PurchaseStatus = () => {
        const status = purchase.status;

        if (status === 'verified' || hasPurchased) {
            return <span className={`${classes.badge} ${classes.ownerBadge}`}><CheckIcon style={{ fontSize: 16 }} /> Purchased</span>
        }

        if (status === 'failed' || status === 'expired') {
            return <span className={`${classes.badge} ${classes.failedBadge}`}><ErrorIcon style={{ fontSize: 16 }} /> Purchase Failed</span>
        }

        if (status === 'pending') {
            return <span className={`${classes.badge} ${classes.pendingBadge}`}><CircularProgress color="secondary" style={{marginBottom: -2}} size={17} /> Pending...</span>
        }

        return <></>
    }

    const RegularToolbar = () => {
        return purchase.status === 'verified' ? [] : <Button
            className={classes.actionButton}
            fullWidth
            size='large'
            variant='contained'
            onClick={() => _onPurchase(product)}
        >
            {status ? status : 'Purchase with MetaMask'}
        </Button>
    }
    const Toolbar = isOwner ? RegularToolbar : hasPurchased ? PurchasedToolbar : RegularToolbar;

    const UserBadge = ({ userId }) => {
        const [show, setPopover] = useState(false);
        const shouldShow = Boolean(show);
        return (
            <span className={`${classes.badge} ${classes.seller}`}
                onMouseEnter={(evt) => setPopover(evt.currentTarget)}
                onMouseLeave={() => setPopover(null)}
            >
                <Stack direction="row" alignItems="center">
                    <SellIcon style={{fontSize:16, marginRight: 2}} />{userId.substring(0, 5)}
                    <Popover transitionDuration={0} transformOrigin={{horizontal: 'center', vertical: 'bottom'}} open={shouldShow} onClose={() => setPopover(null)} anchorEl={show}>
                        <Stack direction="row" alignItems="center" style={{padding: 15}}>
                            <Link underline="hover" href={`https://etherscan.io/address/${userId}`} target="_blank">View Seller on Etherscan 
                            </Link>
                            &nbsp;<OpenInNewIcon style={{ fontSize:16  }} />
                        </Stack>
                    </Popover>
                </Stack>
            </span>
        );
    }

    return (
        <>
            <Dialog
                open={helloMetamask}
                onClose={() => setHelloMetamask(false)}
            >
                <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
                    <img alt="no" style={{ position: 'relative', bottom: -5 }} src={`${process.env.PUBLIC_URL}/metamask.svg`} width="100" /><br />
                    Looks like you don't have Metamask installed
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Metamask is the most popular browser based cryptocurrency wallet. It's free. You'll need it to buy this product. Would you like to install it?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setHelloMetamask(false)} variant="outlined" color="primary">No</Button>{' '}
                    <Button onClick={doMetamaskOnboarding} endIcon={<OpenInNewIcon />} variant="contained" color="primary">Yes, Install It</Button>
                </DialogActions>
            </Dialog>

            <Grid container spacing={0} direction="row" alignItems="center" justifyContent="center" className={classes.root}>
                <Grid item className={classes.content}>
                    <h1 className={classes.productName}>{product.title}</h1>

                    <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                        <span className={`${classes.badge} ${classes.price}`}>{product.price} ETH</span>{' '}
                        <UserBadge userId={product.userId} />
                        <PurchaseStatus />
                    </Stack>

                    {product.description && (
                        <p className={classes.productDesc}>{product.description}</p>
                    )}

                    <div className={classes.hr}></div>

                    <div className={classes.center}>
                        <Toolbar />
                    </div>
                </Grid>
            </Grid>
        </>
    )
};
